import { CANNED_RESOURCE_ACTIONS } from "components/dashboard/TrainSAM/CannedResponses/enum";
import DeleteUpdateModal from "./DeleteUpdateModal/DeleteUpdateModal";
import NewUpdateModal from "./NewUpdateModal/NewUpdateModal";

const { CREATE_CANNED_RESOURCE, EDIT_CANNED_RESOURCE, DELETE_CANNED_RESOURCE } =
    CANNED_RESOURCE_ACTIONS;

const CannedUpdatesModal = ({
    title,
    showModal,
    closeModal,
    cannedResourceType,
    selectedCannedUpdate,
    isEdit,
    modalAction,
    toggleModal,
    handleSuccess,
    ...rest
}) => {
    const renderBasedOnModalAction = () => {
        switch (modalAction) {
            case CREATE_CANNED_RESOURCE:
            case EDIT_CANNED_RESOURCE:
                return (
                    <NewUpdateModal
                        title={title}
                        showModal={showModal}
                        closeModal={closeModal}
                        cannedResourceType={cannedResourceType}
                        selectedCannedUpdate={selectedCannedUpdate}
                        isEdit={modalAction === EDIT_CANNED_RESOURCE}
                        handleSuccess={handleSuccess}
                        {...rest}
                    />
                );

            case DELETE_CANNED_RESOURCE:
                return (
                    <DeleteUpdateModal
                        {...{ closeModal, showModal, handleSuccess }}
                        cannedUpdateId={selectedCannedUpdate?.agentUpdateId}
                    />
                );

            default:
                return "";
        }
    };

    return <>{renderBasedOnModalAction()}</>;
};

export default CannedUpdatesModal;
